import { useEffect, useRef, useState } from "react";
import { Hammer, Lightning, TreeEvergreen, SprayBottle } from "@phosphor-icons/react";

const ICONS = [
  { Icon: Hammer, color: "#FF6B35", name: "construção" },
  { Icon: Lightning, color: "#FFCC00", name: "elétricas" },
  { Icon: TreeEvergreen, color: "#16A34A", name: "jardim" },
  { Icon: SprayBottle, color: "#0EA5E9", name: "limpeza" },
];

export default function IntroductionLoader({ onDone, minDurationMs = 1600, busy = false }) {
  const [iconIdx, setIconIdx] = useState(0);
  const [elapsed, setElapsed] = useState(0);
  const busyRef = useRef(busy);
  const doneRef = useRef(false);
  const onDoneRef = useRef(onDone);

  useEffect(() => { busyRef.current = busy; }, [busy]);
  useEffect(() => { onDoneRef.current = onDone; }, [onDone]);

  useEffect(() => {
    const start = Date.now();
    const iconTimer = setInterval(() => setIconIdx((i) => (i + 1) % ICONS.length), 360);
    const tick = setInterval(() => {
      const el = Date.now() - start;
      setElapsed(el);
      if (!doneRef.current && el >= minDurationMs && !busyRef.current) {
        doneRef.current = true;
        clearInterval(iconTimer);
        clearInterval(tick);
        setTimeout(() => onDoneRef.current?.(), 250);
      }
    }, 100);
    return () => { clearInterval(iconTimer); clearInterval(tick); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { Icon, color, name } = ICONS[iconIdx];

  return (
    <div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center"
      style={{ background: "linear-gradient(160deg, #004E98 0%, #003A73 100%)" }}
      data-testid="introduction-loader"
    >
      <div className="relative w-44 h-44 flex items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-white/10 animate-ping" />
        <span className="absolute inset-3 rounded-full bg-white/5" />
        <div
          key={iconIdx}
          className="relative w-28 h-28 rounded-full bg-white shadow-2xl flex items-center justify-center"
          style={{ animation: "ajPop 360ms ease-out" }}
        >
          <Icon size={56} weight="duotone" color={color} />
        </div>
      </div>
      <div className="mt-8 text-center">
        <div className="font-heading font-black text-3xl text-white tracking-tight">
          Aluga<span className="text-[#FF6B35]">Já</span>
        </div>
        <div className="mt-1 text-xs uppercase tracking-[0.3em] text-white/60" data-testid="loader-category">
          {name}
        </div>
      </div>
      <div className="mt-6 w-40 h-1 bg-white/10 rounded-full overflow-hidden">
        <div
          className="h-full bg-[#FF6B35] rounded-full transition-all"
          style={{ width: `${Math.min(100, (elapsed / minDurationMs) * 100)}%` }}
        />
      </div>
      <style>{`
        @keyframes ajPop {
          0% { transform: scale(0.6); opacity: 0; }
          60% { transform: scale(1.08); opacity: 1; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
